"use client"

import { Address } from "@/app/wallet-connect/address"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { ProfileMoleculeReatom } from "../store/index.reatom"

export const ProfilePreviewReatom = reatomComponent(() => {
  const { walletAddress } = useMolecule(ProfileMoleculeReatom)

  return <AddressView walletAddress={walletAddress} />
})

export function AddressView(props: { walletAddress: UnionAddress }) {
  return (
    <Address
      className="font-headline text-xl"
      address={props.walletAddress}
      withCopyIcon={false}
    />
  )
}
